var map = {
	"./boostrap.svg": 450,
	"./c.svg": 949,
	"./css.svg": 742,
	"./docker.svg": 83,
	"./express-js.svg": 938,
	"./figma.svg": 209,
	"./firebase-hosting.svg": 205,
	"./firebase.svg": 890,
	"./git.svg": 573,
	"./heroku.svg": 656,
	"./html.svg": 960,
	"./java.svg": 838,
	"./javascript.svg": 623,
	"./material-ui.svg": 725,
	"./mongodb.svg": 703,
	"./mysql.svg": 640,
	"./next-js.svg": 481,
	"./node-js.svg": 365,
	"./php.svg": 2,
	"./postman.svg": 668,
	"./python.svg": 135,
	"./react-js.svg": 964,
	"./semantic-ui.svg": 743,
	"./tailwind.svg": 352,
	"./vercel.svg": 621,
	"./xampp.svg": 763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 353;